import { render, staticRenderFns } from "./TruckPresetDetail.vue?vue&type=template&id=5dafb712&"
import script from "./TruckPresetDetail.vue?vue&type=script&lang=js&"
export * from "./TruckPresetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports